<template>
  <div class="ts-badge" :class="[type, size]"></div>
</template>

<style lang="scss" scoped>
.ts-badge {
  width: 16px;
  height: 16px;
  border-radius: 14px;

  &.mini {
    width: 10px;
    height: 10px;
  }

  &.micro {
    width: 5px;
    height: 5px;
  }

  &.success {
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    // border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: normal, soft-light, normal;
    background-clip: border-box;
    background-image: linear-gradient(to bottom, #99ffd1, #99ffd1), linear-gradient(318deg, #000000, #ffffff -5%),
      linear-gradient(to bottom, #ebecf0, #ebecf0);
  }

  &.error {
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    // border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: normal, soft-light, normal;
    background-clip: border-box;
    background-image: linear-gradient(to bottom, #ff9a8f, #ff9a8f), linear-gradient(318deg, #000000, #ffffff -5%),
      linear-gradient(to bottom, #ebecf0, #ebecf0);
  }

  &.neutral {
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    // border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: normal, soft-light, normal;
    background-clip: border-box;
    background-image: linear-gradient(to bottom, #6d7587, #a6abbd), linear-gradient(318deg, #000000, #ffffff -5%),
      linear-gradient(to bottom, #6d7587, #a6abbd);
  }
}
</style>

<script>
export default {
  name: 'TsBadge',
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'normal'
    }
  }
};
</script>
